import ReactPixel from "react-facebook-pixel";

export const initFacebookPixel = (pixelId: string) => {
  ReactPixel.init(pixelId);
  ReactPixel.pageView(); // For initial page load
};

export const trackPixelEvent = (event: string, data = {}) => {
  ReactPixel.track(event, data);
};
